import { FC } from "react";

import FourOhFour from "../FourOhFour/FourOhFour";

interface Props {
  message: string;
}

const UserFriendlyInfoPage: FC<Props> = ({ message }) => (
  <FourOhFour message={message} dataTestId={"user_friendly_info_page"} />
);

export default UserFriendlyInfoPage;
